
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Ladiespginhinjewadiphasenearcageminiinfosys() {



    const cardData =
    {
        keyword: 'Ladies PG in Hinjewadi Phase 1 Near Capgemini & Infosys ',
        heading: 'Shree Swami Samarth PG: Ladies PG in Hinjewadi Phase 1 Near Capgemini & Infosys',
        headingDescription: 'Shree Swami Samarth PG provides secure and comfortable ladies PG in Hinjewadi Phase 1 near Capgemini & Infosys, offering a safe and homely stay for working women and students. Located just minutes away from top IT companies, our PG ensures minimal commute time and excellent connectivity to major business hubs, shopping centers, and public transport. The rooms are fully furnished, spacious, and designed with privacy and comfort in mind, featuring cozy bedding, study/work setups, and ample storage space. Residents enjoy hygienic home-cooked meals, high-speed WiFi, 24x7 water supply, CCTV surveillance, and disciplined management for complete safety and convenience. With regular housekeeping, peaceful surroundings, and affordable rent plans, Shree Swami Samarth PG in Hinjewadi Phase 1 is the ideal choice for women seeking reliable, secure, and well-managed accommodation near Capgemini and Infosys.',

        top: 'Top Facilities at Shree Swami Samarth PG ',

"topFacilities": [
  {
    "title": "Safe & Professional Living Environment",
    "description": "Ladies PGs in Hinjewadi Phase 1, near Infosys and Capgemini, are located in well-maintained, secure neighborhoods. These properties offer female-only or unisex options with trusted professional management. Common safety features include CCTV surveillance, regulated visitor entry, and responsible staff—helping residents feel secure at all hours. This level of assurance is especially valued by working women and students living away from home."
  },
  {
    "title": "Furnished Rooms with Sharing Options",
    "description": "Residents can choose from fully furnished rooms—ranging from private singles to twin or triple sharing based on budget and preference. Each room typically includes a bed, wardrobe, study desk, and chair. Shared rooms are designed smartly to maintain privacy alongside affordability. This flexibility makes it easier for women professionals or students to pick a setup that suits both their comfort and wallet."
  },
  {
    "title": "Meal-Inclusive Plans Available",
    "description": "Many ladies’ PGs near Infosys/Capgemini include hygienic meals (breakfast, lunch, and dinner) in the monthly rent. This saves time for busy working women who may not want the hassle of cooking. Several establishments let you include or exclude meals based on your preference—offering a good mix of convenience and flexibility for residents."
  },
  {
    "title": "High-Speed Wi-Fi and Power Backup",
    "description": "These PGs offer high-speed Wi-Fi throughout the premises, supporting online meetings, remote work, or virtual classes. Power backup ensures uninterrupted connectivity—especially during outages. This makes it easy for female professionals to stay productive, attend virtual meetings, or connect with friends and family without interruption."
  },
  {
    "title": "Prime Location Near IT Campuses",
    "description": "Living in Hinjewadi Phase 1 means quick access to major employers like Infosys, Capgemini, Wipro, and Cognizant. This significantly cuts commuting time, improving work-life balance. The area is also close to bus routes, metro access, shopping hubs, and wellness centers—greatly enhancing everyday convenience."
  },
  {
    "title": "Cleanliness and Laundry Support",
    "description": "Daily or regular housekeeping maintains hygiene in rooms and common areas, while many PGs offer in-house or outsourced laundry facilities. Such services help residents focus on their careers or studies instead of daily chores, adding a layer of comfort and convenience to everyday living."
  },
  {
    "title": "Strong Community & Shared Spaces",
    "description": "Many PGs foster a warm community atmosphere for women—featuring common lounges, TV rooms, or shared dining areas. This setup encourages interaction and support among residents, making it ideal for newcomers settling into Pune. Organized events or informal gatherings help build connections and promote a sense of belonging."
  },
  {
    "title": "Transparent & Affordable Pricing",
    "description": "Prices for ladies’ PGs in this area typically range from ₹6,500/month for shared options up to ₹15,000/month for private rooms, depending on amenities. Many PGs package in food, Wi-Fi, security, and housekeeping—all with clear pricing and no hidden costs. This transparency enables better budgeting for working professionals and families alike."
  }
],


"services": [
  {
    "name": "Ladies PG in Phase 1 Hinjewadi",
    "description": "Shree Swami Samarth PG offers secure and well-maintained Ladies PG accommodations in Phase 1 Hinjewadi, designed specifically for working women and students. Our PG features fully furnished rooms with essential amenities like Wi-Fi, 24/7 security, housekeeping, and power backup, ensuring a safe and comfortable living environment close to major IT companies."
  },
  {
    "name": "PG for Girls Near Capgemini Hinjewadi",
    "description": "Located near Capgemini Hinjewadi, our girls’ PG is tailored for female IT professionals seeking convenience and security. The facility offers nutritious meal plans, comfortable rooms, recreational areas, and easy access to transport, making daily commutes hassle-free and comfortable."
  },
  {
    "name": "PG for Female Near Infosys Phase 1",
    "description": "Shree Swami Samarth PG provides specialized female PG accommodations near Infosys Phase 1. Our clean, fully furnished rooms come with safety measures such as CCTV surveillance and security personnel, creating a secure haven for working women and students."
  },
  {
    "name": "Safe PG for Women in Hinjewadi",
    "description": "Our safe PG accommodations for women in Hinjewadi emphasize security and comfort. Features include biometric access, regular security patrols, emergency contact systems, and women-friendly staff, ensuring peace of mind for residents and their families."
  },
  {
    "name": "Girls Hostel Near Infosys Campus",
    "description": "The girls’ hostel near Infosys campus by Shree Swami Samarth PG offers a community-driven environment with shared facilities, study rooms, and social spaces. It’s an ideal option for students and professionals seeking a friendly and secure place to stay."
  },
  {
    "name": "PG for Working Ladies Near Capgemini",
    "description": "Our PG for working ladies near Capgemini Hinjewadi is designed for professional women seeking a balance of comfort, convenience, and safety. Amenities include power backup, Wi-Fi, laundry services, and a supportive community atmosphere."
  },
  {
    "name": "PG for IT Professionals Girls in Hinjewadi Phase 1",
    "description": "Shree Swami Samarth PG offers tailor-made accommodations for female IT professionals in Hinjewadi Phase 1, featuring private and shared rooms, ergonomic furniture, high-speed internet, and proximity to tech parks to minimize commute times."
  },
  {
    "name": "Furnished PG for Women in Phase 1",
    "description": "Our furnished PG for women in Phase 1 Hinjewadi boasts stylish interiors, well-equipped kitchens, comfortable beds, and attached bathrooms. The property is maintained with high hygiene standards and includes amenities to support a productive and peaceful stay."
  }
],
"tableData": [
  ["Ladies PG in Phase 1 Hinjewadi", "PG for Girls Near Capgemini Hinjewadi"],
  ["PG for Female Near Infosys Phase 1", "Safe PG for Women in Hinjewadi"],
  ["Girls Hostel Near Infosys Campus", "PG for Working Ladies Near Capgemini"],
  ["PG for IT Professionals Girls in Hinjewadi Phase 1", "Furnished PG for Women in Phase 1"]
],




"whychoose": [
    {
        "WhyChooseheading": "Safe and Comfortable Ladies PG in Hinjewadi Phase 1",
        "WhyChoosedescription": "Shree Swami Samarth PG offers secure and well-maintained accommodation exclusively for ladies near Capgemini and Infosys in Hinjewadi Phase 1. Designed to provide a homely and peaceful environment, our PG is perfect for working women and interns seeking safety and convenience."
    },
    {
        "WhyChooseheading": "Prime Location Near Major IT Companies",
        "WhyChoosedescription": "Situated close to Capgemini, Infosys, and other leading IT offices, our PG enables easy and quick access to your workplace. Cut down on your daily commute and enjoy more personal time in a comfortable setting."
    },
    {
        "WhyChooseheading": "Fully Furnished Rooms with Modern Amenities",
        "WhyChoosedescription": "Each room is furnished with comfortable beds, wardrobes, study tables, and high-speed Wi-Fi. Clean attached or shared bathrooms, along with air-conditioning options, ensure a comfortable stay regardless of the season."
    },
    {
        "WhyChooseheading": "Nutritious and Hygienic Meals Provided",
        "WhyChoosedescription": "Enjoy freshly cooked, balanced meals served three times a day with both vegetarian and non-vegetarian options. Our kitchen follows strict hygiene protocols to provide healthy and tasty food for our residents."
    },
    {
        "WhyChooseheading": "24/7 Security with Female-Friendly Policies",
        "WhyChoosedescription": "Safety is our top priority. The premises are monitored by CCTV cameras, biometric access controls, and staffed by trained personnel to ensure a secure living environment for all female residents."
    },
    {
        "WhyChooseheading": "All-Inclusive Rent with No Hidden Charges",
        "WhyChoosedescription": "Our rent covers accommodation, meals, electricity, Wi-Fi, housekeeping, and laundry services. Transparent pricing with flexible lease terms makes it easy for you to plan your stay without any surprises."
    },
    {
        "WhyChooseheading": "Supportive Community and Friendly Staff",
        "WhyChoosedescription": "Live in a respectful and harmonious community with other like-minded professional women. Our staff is always available to assist you with any needs, ensuring a comfortable and stress-free experience."
    },
    {
        "WhyChooseheading": "Ideal for Working Women and Female Interns",
        "WhyChoosedescription": "Whether you’re starting a new job or interning near Hinjewadi, Shree Swami Samarth PG provides a peaceful and convenient base that helps you focus on your career and personal growth."
    }
]

























    }
    
const faqData = [
    {
        question: "How can I book a ladies PG in Hinjewadi Phase 1 near Capgemini & Infosys?",
        answer: "You can book your room by calling us at +91 9594917913. We also offer online booking and virtual tours."
    },
    {
        question: "Is your ladies PG located near Capgemini and Infosys in Hinjewadi Phase 1?",
        answer: "Yes, our PG is conveniently situated close to Capgemini and Infosys campuses, ideal for working professionals."
    },
    {
        question: "What types of rooms are available in the ladies PG?",
        answer: "We offer single and double sharing fully furnished rooms with attached bathrooms and modern amenities."
    },
    {
        question: "Is food included in the ladies PG rent?",
        answer: "Yes, freshly prepared vegetarian meals—breakfast, lunch, and dinner—are included in the monthly rent."
    },
    {
        question: "What safety measures do you have for female residents?",
        answer: "We provide 24/7 CCTV surveillance, biometric entry, female staff on-site, and restricted visitor access for maximum safety."
    },
    {
        question: "Are there laundry and housekeeping services?",
        answer: "Yes, regular housekeeping and laundry services are included to keep the environment clean and comfortable."
    },
    {
        question: "What is the monthly rent for the ladies PG near Capgemini and Infosys?",
        answer: "Rent depends on room type and amenities. Please contact us directly for current pricing and special offers."
    },
    {
        question: "Is there a minimum stay requirement?",
        answer: "Yes, the minimum stay is one month, with flexible options for longer stays."
    },
    {
        question: "Are guests allowed in the ladies PG?",
        answer: "Guest entry is strictly regulated to ensure the safety and privacy of all residents."
    },
    {
        question: "How do I contact Shree Swami Samarth PG to book a ladies PG in Hinjewadi Phase 1?",
        answer: "Call us at +91 9594917913 for inquiries, booking, and to schedule visits."
    }
];

const testimonialsData = [
    {
        name: 'Ms. Anjali Patil',
        designation: 'Software Engineer, Capgemini Hinjewadi',
        rating: [1, 1, 1, 1, 1],
        text: '“The location near Capgemini and Infosys is perfect. Safe, clean, and comfortable PG with excellent staff support.”',
    },
    {
        name: 'Ms. Riya Kulkarni',
        designation: 'Business Analyst, Infosys Hinjewadi',
        rating: [1, 1, 1, 1, 1],
        text: '“A very secure and well-maintained PG for ladies. The food is tasty and the rooms are cozy and well-furnished.”',
    },
];






























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9209169761",
            "+91 9096665072",

        ],
        email: "reservation@swamisamarthpg.com "
    };


     const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: " PG in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "  Single Room PG in Pune",
        },
        
        {
            place: "/images/keyword/4.jpg",
            text: "  Best Luxury PG in Pune",
        },
       
       
        {
            place: "/images/keyword/13.jpg",
            text: "  Hostel in Pune",
        },

        {
            place: "/images/keyword/15.jpg",
            text: " PG for Working Professionals Pune",
        },
        
        {
            place: "/images/keyword/19.jpg",
            text: "  Paying Guest Near Hinjewadi IT Park Pune",
        },
        

    ];


    const images = [
        { src: "./images/gallery/1.jpg", alt: "Image 1" },
        { src: "./images/gallery/2.jpg", alt: "Image 1" },
        { src: "./images/gallery/3.jpg", alt: "Image 1" },
        { src: "./images/gallery/4.jpg", alt: "Image 1" },
        { src: "./images/gallery/5.jpg", alt: "Image 1" },
        { src: "./images/gallery/6.jpg", alt: "Image 1" },
        { src: "./images/gallery/7.jpg", alt: "Image 1" },
        { src: "./images/gallery/8.jpg", alt: "Image 1" },
        { src: "./images/gallery/9.jpg", alt: "Image 1" },

    ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Ladies PG in Hinjewadi Phase 1 Near Capgemini & Infosys",
  "image": "https://swamisamarthpg.com/assets/images/ladies-pg-hinjewadi-phase1.jpg", // Replace with actual image URL
  "description": "Safe and furnished ladies PG in Hinjewadi Phase 1 near Capgemini and Infosys. Ideal for female IT professionals and working ladies seeking comfortable accommodation.",
  "brand": {
    "@type": "Brand",
    "name": "Shree Swami Samarth PG"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.94",
    "ratingCount": "1900"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "9800",  // Replace with actual price if needed
    "availability": "https://schema.org/InStock",
    "url": "https://swamisamarthpg.com/ladies-pg-hinjewadi-phase1"  // Replace with actual page URL if different
  }
};






    return (
        <div>
<Helmet>
  <title>Ladies PG in Hinjewadi Phase 1 Near Capgemini & Infosys | Safe & Furnished</title>
  <meta 
    name="description" 
    content="Safe and furnished ladies PG near Capgemini and Infosys in Hinjewadi Phase 1. Perfect accommodation for female IT professionals and working women." 
  />
  <meta 
    name="keywords" 
    content="Ladies PG in Phase 1 Hinjewadi, PG for Girls Near Capgemini Hinjewadi, PG for Female Near Infosys Phase 1, Safe PG for Women in Hinjewadi, Girls Hostel Near Infosys Campus, PG for Working Ladies Near Capgemini, PG for IT Professionals Girls in Hinjewadi Phase 1, Furnished PG for Women in Phase 1" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(images/background/3.jpg)`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    color: 'white'
  }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/28.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF6403', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topFacilities.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                          

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Shree Swami Samarth PG</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                {/* <FAQKeyword faqs={faqData} /> */}
                <Accordion data={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #FF6403',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF6403' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919209169761" className="d-block  text-white">+91 9209169761</a>
                                                <a href="tel:+919096665072" className="d-block  text-white">+91 9096665072</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF6403' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:reservation@swamisamarthpg.com " className=" text-white d-block">
                                                    reservation@swamisamarthpg.com 
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF6403' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Shree Swami Samarth PG  <br />
                                                        M.No. 03065, No. 258/1/3, Mukai Nagar, B.H. MRF Showroom, Pune 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Ladiespginhinjewadiphasenearcageminiinfosys;